import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, makeStyles, Typography } from '@popmenu/common-ui';

type SignInLayoutProps = {
  children: React.ReactNode
  description?: React.ReactNode
  heading: React.ReactNode
  icon?: React.ReactNode
  title: string
}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    margin: '0 auto',
    maxWidth: 440,
    padding: theme.spacing(2, 0, 4),
  },
  description: {
    color: theme.palette.text.secondary,
  },
  heading: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  intro: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

// Shared column for the sign-in, check-email and welcome pages, which stay out of search results
export const SignInLayout = ({ children, description, heading, icon, title }: SignInLayoutProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Helmet title={title}>
        <meta name="robots" content="noindex" />
      </Helmet>
      {icon}
      <Box className={classes.intro}>
        <Typography className={classes.heading} component="h1" variant="h4">
          {heading}
        </Typography>
        {description && (
          <Typography className={classes.description}>
            {description}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  );
};
